import { RootState } from 'editor/src/store/index';

const getNextStates = (state: RootState) => state.editorModules.undoRedo.next;

export default getNextStates;
